import { render, staticRenderFns } from "./add_template.vue?vue&type=template&id=d2bb966c&scoped=true"
import script from "./add_template.vue?vue&type=script&lang=js"
export * from "./add_template.vue?vue&type=script&lang=js"
import style0 from "./add_template.vue?vue&type=style&index=0&id=d2bb966c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb966c",
  null
  
)

export default component.exports